import React from 'react';
import Tag, { TagColor } from '../../../../../muiComponents/Tag';

interface ScraperStatusTagProps {
    text: string;
    color: TagColor;
    size?: 'small' | 'medium';
}

/**
 * Outlined status tag used to flag scraped services and attributes.
 * @param props - Status text, its color and the tag size.
 * @returns The status tag centered in its container.
 */
const ScraperStatusTag = ({
    text,
    color,
    size = 'medium',
}: ScraperStatusTagProps) => (
    <div className='flex flex-center'>
        <Tag
            text={text}
            variant='outlined'
            color={color}
            uppercase
            size={size}
        />
    </div>
);

export default ScraperStatusTag;
